import { useUI } from "@context/ui-managed-context";
import Button from "@elements/button";
import CloseIcon from "@svg/closeIcon";
// import Button from "@elements/redesign/Button/Button";
import Verified from "@svg/redesign/Verified";
import { useTranslations } from "next-intl";
import Image from "next/legacy/image";
import { useRouter } from "next/router";

interface VerifyPhoneNumberSuccessProps { }

const VerifyPhoneNumberSuccess: React.FC<VerifyPhoneNumberSuccessProps> = () => {
  const { closeModal, modalView } = useUI();
  const t = useTranslations();
  const { locale, reload } = useRouter();
  const onComplete: undefined | ((finishedAndVerified: boolean) => void) = modalView.args[1]

  const handelClose = () => {
    onComplete?.(true);
    closeModal();
  };
  const ShouldReload: boolean | undefined = modalView.args[0]
  return (
    <div className="md:w-[480px] sm:w-screen xs:w-screen w-screen max-w-[480px] h-max" dir={locale?.includes("ar-") ? "rtl" : "ltr"}>
      <div className="w-full max-h-[728px] h-screen  bg-success-gradient rounded-3xl p-6 flex flex-col gap-3 items-center md:rounded-3xl justify-between rounded-b-none overflow-auto no-scrollbar">
        <div className="w-full flex justify-end">
          <button
            className=" outline-none"
            onClick={() => {
              handelClose();
              if (ShouldReload) {
                reload()
              }
            }}
          >
            <CloseIcon />
          </button>
        </div>
        <div className="w-full max-w-[332px] aspect-square relative">
          <Image
            src="/imgs/success-verification.webp"
            alt="success"
            layout="fill"
            objectFit="contain"
            quality={75}
          />
        </div>
        <div className="w-full flex flex-col gap-3 items-center">
          <Verified />
          <h3 className="text-black text-lg font-bold leading-8 text-center">{t("client_phoneverify_phoneverified")}</h3>
          <p className="text-mui-text-secondary text-center text-sm font-medium leading-5">
            {t("client_phoneverify_safeaccount").split("@")[0]} <br /> {t("client_phoneverify_safeaccount").split("@")[1]}
          </p>
        </div>
        <div className="w-full grid grid-cols-1 gap-4 mt-10">
          <Button
            theme="blue"
            className="!font-bold !h-12 rounded-full text-sm "
            onClick={() => {
              handelClose();
              if (ShouldReload) {
                reload()
              }
            }}
          >
            {t("client_buttons_done")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VerifyPhoneNumberSuccess;